<template>
  <div class="">
    <div class="neiye_banner">
      <BANNER></BANNER>
    </div>
    <div class="main">
      <div class="container">
        <div class="location">
          <router-link to="/">网站首页</router-link>
          <router-link to="/yygk/home">&nbsp;&gt;&nbsp;医院概况</router-link>
          <router-link to="/yygk/rencaipeiyang"
            >&nbsp;&gt;&nbsp;人才培养</router-link
          >
        </div>
        <div class="tv_main clearfix">
          <div class="sjjj_main_left fl">
            <SLIDE></SLIDE>
          </div>
          <div class="sjhy_main_right fr">
            <ARTICLE :current="current"></ARTICLE>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import service from "../../service/yygk";
import BANNER from "../../components/banner/yygk";
export default {
  name: "RENCAIPEIYANG",
  data() {
    return {
      current: {},
    };
  },
  components: {
    BANNER,
  },
  computed: {},
  created() {
    this.init();
  },
  beforeMount() {},
  methods: {
    init() {
      service.getHosOverviewPersonnel({}, (res) => {
        this.current = { ...res };
      });
    },
  },
  mounted() {},
  watch: {},
};
</script>

<style>
</style>
